module.exports = __webpack_public_path__ + "img/Feature.801cada6.jpg";